// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline___O7Sy","title":"styles_title__YXPyL","subtitle":"styles_subtitle__JKQjt"};